// Where the contact form sends enquiries.
// With REACT_APP_LEAD_ENDPOINT set to the /lead API route, enquiries become Zoho CRM leads (see lambda/lead-api.js).
// Without it, they go to Formspree exactly as before, so the form keeps working until the route is deployed.
export const LEAD_ENDPOINT = process.env.REACT_APP_LEAD_ENDPOINT || "";
export const FORMSPREE_ENDPOINT = "https://formspree.io/f/xnnokkze";
